/* tslint:disable */
/* eslint-disable */
/* @relayHash a0c69ce7f5cf37717596034f7bb48565 */

import { ConcreteRequest } from "relay-runtime";
export type DesignProfileBasicMutationInput = {
    serviceId: string;
    about?: string | null;
    email?: string | null;
    clientMutationId?: string | null;
};
export type profileAboutMutationVariables = {
    input: DesignProfileBasicMutationInput;
};
export type profileAboutMutationResponse = {
    readonly designProfileBasicMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly about: string | null;
            } | null;
        } | null;
    } | null;
};
export type profileAboutMutation = {
    readonly response: profileAboutMutationResponse;
    readonly variables: profileAboutMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DesignProfileBasicMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publicProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "about",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileAboutMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "designProfileBasicMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileBasicMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileAboutMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "designProfileBasicMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileBasicMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileAboutMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileAboutMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'cd9de4ad4cdf0c03f4beb634c66cd288';
export default node;
